export const en = {
  verificationWizardPage: {
    errors: {
      checkVerification: 'Failed to verify verification status',
      userNotFound: 'User information not found',
      verificationFailed: 'Failed to complete verification',
    },
    success: {
      verificationSubmitted: 'Verification submitted successfully',
    },
  },
  wizardProgress: {
    steps: {
      terms: 'Terms',
      info: 'Information',
      contract: 'Contract',
      bank: 'Bank Information',
    },
  },
  bankStep: {
    headers: {
      bankInformation: 'Bank Information',
    },
    labels: {
      bankName: 'Bank Name',
      accountNumber: 'Account Number',
      swiftCode: 'SWIFT / BIC Code',
      bankBranch: 'Bank Branch',
      ifscCode: 'RTGS / NEFT / IFSC Code',
    },
    placeholders: {
      bankName: 'Enter bank name',
      accountNumber: 'Enter your account number',
      swiftCode: 'Example: BOFAUS3N',
      bankBranch: 'Enter branch name',
      ifscCode: 'Example: ABCD0123456',
    },
    errors: {
      bankNameRequired: 'Bank name is required',
      accountNumberInvalid: 'Invalid account number format (10-20 digits)',
      swiftCodeInvalid: 'Invalid SWIFT/BIC code format',
      bankBranchRequired: 'Bank branch is required',
      ifscCodeInvalid: 'Invalid IFSC code format',
    },
    buttons: {
      back: 'Back',
      submit: 'Submit',
    },
    validationMessages: {
      requiredField: 'This field is required',
      validAccountNumber: 'Account number must be between 10 and 20 digits',
      validSwiftCode:
        'SWIFT code must consist of 6 characters followed by 2 or 3 digits/letters',
    },
    success: {
      formSubmitted: 'Form submitted successfully',
    },
  },
  contractStep: {
    headers: {
      contractReview: 'Contract Review',
      contractName: 'Marketing Services Agreement',
    },
    subHeaders: {
      reviewMessage: 'Please review the contract before signing',
      languageSelection: 'Please select the language for your contract',
    },
    labels: {
      digitalSignature: 'Digital Signature (type your full name)',
    },
    placeholders: {
      signature: 'Type your full name as signature',
    },
    buttons: {
      viewContract: 'View Contract Template',
      generateContract: 'Generate Contract',
      generatingContract: 'Generating contract...',
      downloadContract: 'Download Signed Contract',
      next: 'Next',
      submit: 'Submit',
      back: 'Back',
    },
    success: {
      contractGenerated: 'Contract generated successfully',
    },
    errors: {
      noSignature: 'Please provide your digital signature',
      contractGeneration: 'Failed to generate contract, please try again',
    },
  },
  infoStep: {
    title: 'Personal Information',
    labels: {
      fullName: 'Full Name (as in passport)',
      passportNumber: 'Passport Number',
      passportIssuanceDate: 'Passport Issuance Date',
      nationality: 'Nationality',
      country: 'Country of Residence',
      mobileNumber: 'Mobile Number',
      email: 'Email',
      agent: 'Agent/Company Name',
    },
    placeholders: {
      fullName: 'Enter full name',
      passportNumber: 'Enter passport number',
      nationality: 'Enter nationality',
      country: 'Enter country of residence',
      mobileNumber: '+1234567890',
      email: 'example@domain.com',
      agent: 'Enter company name',
    },
    errors: {
      fullName: 'Full name must be at least 3 characters',
      passportNumber: 'Invalid passport number format',
      issuanceDateRequired: 'Issuance date is required',
      invalidDate: 'Invalid date format',
      futureDate: 'Issuance date cannot be in the future',
      oldDate: 'Issuance date cannot be older than 10 years',
      nationalityRequired: 'Nationality is required',
      countryRequired: 'Country of residence is required',
      invalidMobile: 'Invalid mobile number format',
      invalidEmail: 'Invalid email format',
      agentRequired: 'Agent/Company name is required',
    },
    buttons: {
      back: 'Back',
      next: 'Next',
    },
  },
  terms: {
    title: 'Acknowledgment and Commitment',
    acknowledgment:
      'I, the undersigned, acknowledge and commit to the following:',
    compliance:
      'Compliance with all terms of the Marketing Services Agreement signed with ithraa alkhair for Hajj Services.',
    provideServices: 'Provide marketing services as follows:',
    promotePackages:
      'Promote the features of ithraa alkhair packages and services through digital media, social media, events, and exhibitions.',
    encouragePilgrims:
      'Encourage pilgrims to register on the Nusuk platform and closely monitor the registration process.',
    submitList:
      'Submit a list of pilgrims registered on the Nusuk platform before the package purchase phase begins.',
    adhereTo: 'Adhere to the following:',
    uploadData: 'Upload pilgrims data within the specified timeframe.',
    ensureAccuracy:
      'Ensure data accuracy and avoid duplication or matching with data of any other guide.',
    clearMessages:
      'Use clear marketing messages aligned with religious and cultural values.',
    noComplaints:
      'Ensure there are no complaints or issues regarding provided services.',
    legalResponsibility:
      'Assume full legal and financial responsibility in case of any breach of the above commitments.',
    agreeTerms: 'I agree to the above terms and conditions',
    next: 'Next',
  },
  verification: {
    detailsTitle: 'Verification Details',
    created: 'Created',
    lastUpdated: 'Last Updated',
    rejectionReason: 'Rejection Reason',
    viewContract: 'View Contract',
    delete: 'Delete',
    deleteSuccess: 'Verification deleted successfully',
    deleteError: 'Failed to delete verification',
    userType: 'User Type',
    createdAt: 'Created At',
    personalInfo: 'Personal Information',
    bankInfo: 'Bank Information',
    digitalSignature: 'Digital Signature',
    bankName: 'Bank Name',
    accountNumber: 'Account Number',
    swiftCode: 'SWIFT Code',
    bankBranch: 'Bank Branch',
    ifscCode: 'IFSC Code',
    noBankInfo: 'No bank information provided',
    bankInfoUpdated: 'Bank information updated successfully',
    bankInfoError: 'Failed to update bank information',
    viewSignedContract: 'View Signed Contract',
  },
  verificationApproval: {
    statuses: {
      approved: 'Approved',
      rejected: 'Rejected',
      pending: 'Pending',
    },
    userTypes: {
      guide: 'Guide',
      organizer: 'Organizer',
    },
    createdAt: 'Created At',
    buttons: {
      viewContract: 'View Contract',
      delete: 'Delete',
      approve: 'Approve',
      reject: 'Reject',
      export: 'Export',
      downloadContracts: 'Download Contracts',
      cancel: 'Cancel',
    },
    bankInfo: {
      title: 'Bank Information',
      bankName: 'Bank Name',
      accountNumber: 'Account Number',
      swiftCode: 'SWIFT Code',
      bankBranch: 'Bank Branch',
      ifscCode: 'IFSC Code',
    },
    filters: {
      searchPlaceholder: 'Search...',
      allStatuses: 'All Statuses',
      pending: 'Pending',
      approved: 'Approved',
      rejected: 'Rejected',
      allTypes: 'All Types',
      guides: 'Guides',
      organizers: 'Organizers',
      activeFilters: 'Active Filters:',
      search: 'Search',
      status: 'Status',
      type: 'Type',
    },
    dialog: {
      approveTitle: 'Approve Verification',
      rejectTitle: 'Reject Verification',
      deleteTitle: 'Delete Verification',
      approveMessage: 'Are you sure you want to approve this verification?',
      rejectMessage: 'Are you sure you want to reject this verification?',
      rejectionReasonLabel: 'Reason for Rejection',
      deleteMessage:
        'Are you sure you want to delete this verification for {name}? This action cannot be undone.',
    },
  },
  pilgrimSelector: {
    searchPlaceholder: 'Search by name, passport, or country...',
    passport: 'Passport',
    arrivalDate: 'Arrival Date',
    noResults: 'No matching pilgrims found',
    startSearch: 'Start searching for a pilgrim...',
  },
  header: {
    refresh: 'Refresh',
    refreshing: 'Refreshing...',
    refreshSuccess: 'Data updated successfully',
    refreshError: 'Failed to update data',
  },
  verificationPage: {
    verifying: 'Verifying...',
    verifyNow: 'Verify Now',
    clickButton:
      'Click the button to verify the data linkage between pilgrims, packages, and trips',
  },
  team: {
    title: 'Team',
    addMember: 'Add Member',
  },
  evidenceViewModal: {
    title: 'Guide Evidence',
    noEvidence: 'No evidence submitted yet',
    textEvidence: 'Text Evidence',
    imageEvidence: 'Attached Image',
    submittedAt: 'Submission Date',
    updatedAt: 'Last Updated',
  },
  disputeCard: {
    selectGuide: 'A guide must be selected',
    resolveSuccess: 'Dispute resolved successfully',
    resolveError: 'Failed to resolve the dispute',
    emailSubject:
      'Important: Guide Verification Required - Technical Support from ithraa alkhair',
    emailBodyPart1: 'Dear',
    emailBodyPart2:
      'We are contacting you from ithraa alkhair Technical Support regarding your Hajj arrangements.',
    emailBodyPart3:
      'We have received conflicting information regarding your appointed guide. According to our records, both',
    emailBodyPart4: 'claim to be your official guide.',
    emailBodyPart5:
      'Can you confirm who your appointed guide is? This information is crucial to ensure proper service during your Hajj trip.',
    emailBodyPart6: 'Best regards,',
    emailBodyPart7: 'ithraa alkhair Technical Support Team',
    emailNotAvailable: 'Email not available',
    whatsAppMessage1: 'Dear',
    whatsAppMessage2:
      'ithraa alkhair Technical Support team is contacting you regarding your Hajj arrangements.',
    whatsAppMessage3:
      'We have received conflicting information regarding your appointed guide. According to our records, both',
    whatsAppMessage4: 'claim to be your official guide.',
    whatsAppMessage5:
      'Can you confirm who your appointed guide is? This information is crucial to ensure proper service during your Hajj trip.',
    whatsAppMessage6: 'Best regards,',
    whatsAppMessage7: 'ithraa alkhair Technical Support Team',
    phoneNotAvailable: 'Phone number not available',
    sendEmail: 'Send Email',
    sendWhatsApp: 'Send via WhatsApp',
    countryNotAvailable: 'Country not available',
    passport: 'Passport',
    viewEvidence: 'View Evidence',
    resolveDispute: 'Resolve Dispute',
    requestDate: 'Request Date',
  },
  disputesList: {
    noDisputes: 'No disputes match the selected filters',
  },
  disputesPage: {
    header: 'Disputes',
    description: 'Manage disputes between guides over pilgrim ownership',
  },
  linkingStats: {
    totalPilgrims: 'Total Pilgrims',
    countries: 'Number of Countries',
    approved: 'Linked',
    pending: 'Pending',
    rejected: 'Rejected',
  },
  linkingTableRow: {
    status: {
      approved: 'Linked',
      rejected: 'Rejected',
      pending: 'Pending',
    },
    labels: {
      passport: 'Passport',
    },
  },
  linkingStatusPage: {
    header: 'Linking Status',
    description: 'Track the linking status between guides and pilgrims',
  },
  verificationHeader: {
    header: 'Verification Linkage',
    description:
      'Verify the data linkage between pilgrims, packages, and trips',
  },
  flightsPage: {
    header: 'Flights',
    downloadTemplate: 'Upload Template Example',
    addFlights: 'Add Flights',
    deleteAll: 'Delete All Flights',
    uploadError: 'Error while uploading data',
    deleteSuccess: 'All flights deleted successfully',
    deleteError: 'Error while deleting flights',
    deleteAllTitle: 'Delete All Flights',
    deleteAllMessage:
      'Are you sure you want to delete all flights? This action cannot be undone.',
    confirmDelete: 'Delete All',
    cancel: 'Cancel',
  },
  packagesPage: {
    header: 'Hajj Packages',
    downloadTemplate: 'Upload Template Example',
    addPackages: 'Add Packages',
    deleteAll: 'Delete All Packages',
    uploadError: 'Error while uploading data',
    deleteSuccess: 'All packages deleted successfully',
    deleteError: 'Error while deleting packages',
    deleteAllTitle: 'Delete All Packages',
    deleteAllMessage:
      'Are you sure you want to delete all packages? This action cannot be undone.',
    confirmDelete: 'Delete All',
    cancel: 'Cancel',
  },
  pilgrimsPage: {
    header: 'Pilgrim Information',
    downloadTemplate: 'Upload Template Example',
    addPilgrims: 'Add Pilgrims',
    deleteAll: 'Delete All Pilgrims',
    uploadError: 'Error while uploading data',
    deleteSuccess: 'All pilgrims deleted successfully',
    deleteError: 'Error while deleting pilgrims',
    deleteAllTitle: 'Delete All Pilgrims',
    deleteAllMessage:
      'Are you sure you want to delete all pilgrims? This action cannot be undone.',
    confirmDelete: 'Delete All',
    cancel: 'Cancel',
  },
  adminDashboard: {
    morningGreeting: 'Good Morning',
    afternoonGreeting: 'Good Afternoon',
    eveningGreeting: 'Good Evening',
    defaultUserName: 'System Admin',
    welcomeMessage: 'Welcome to the Integrated Hajj Packages Management System',
    makkah: 'Makkah',
    madinah: 'Madinah',
    mina: 'Mina',
    holyCity: 'Holy City',
    prophetMosque: "Prophet's Mosque",
    pilgrimsCamp: 'Pilgrim Camps',
    managePilgrims: 'Manage Pilgrims',
    movementSchedule: 'Movement Schedule',
    flights: 'Flights',
    accommodation: 'Accommodation',
  },
  organizerFinance: {
    title: 'Organizer Finance',
    subtitle: 'Manage and track organizer payments based on pilgrim ownership',
    totalPilgrims: 'Total Pilgrims',
    matchingPilgrims: 'Matching Pilgrims',
    mismatchedPilgrims: 'Mismatched Pilgrims',
    totalAmount: 'Total Amount',
    bonusAmount: 'Bonus Amount',
    savedAmount: 'Saved Amount',
    pilgrimName: 'Pilgrim Name',
    passportNumber: 'Passport Number',
    assignedGuide: 'Assigned Guide',
    owner: 'Owner',
    paymentType: 'Payment Type',
    amount: 'Amount',
    status: 'Status',
    matching: 'Matching',
    mismatched: 'Mismatched',
    fullPayment: 'Full Payment',
    guidancePayment: 'Guidance Payment',
    marketingPayment: 'Marketing Payment',
    summary: 'Summary',
    baseAmount: 'Base Amount',
    exportReport: 'Export Report',
    financialStats: {
      totalAmount: 'Total Amount',
      pilgrimsDistribution: 'Pilgrims Distribution',
      savedAmount: 'Saved Amount',
      includesBonus: 'Includes {{bonusAmount}} SAR bonus',
    },
    tableHeaders: {
      pilgrim: 'Pilgrim',
      passport: 'Passport',
      guide: 'Guide',
      owner: 'Owner',
      paymentType: 'Payment Type',
      amount: 'Amount (SAR)',
    },
  },
  common: {
    loading: 'Loading...',
    error: 'Failed to load required data',
  },
  pilgrimOwnership: {
    title: 'Pilgrim Ownership',
    subtitle: 'Manage and determine the true ownership of pilgrims',
  },
  filters: {
    searchPlaceholder: 'Search by pilgrim name or passport number...',
    allCountries: 'All Countries',
    allGenders: 'All Genders',
    male: 'Male',
    female: 'Female',
    activeFilters: 'Active Filters:',
    searchLabel: 'Search:',
    countryLabel: 'Country:',
    genderLabel: 'Gender:',
  },
  tableHeaders: {
    pilgrim: 'Pilgrim',
    assignedGuide: 'Assigned Guide',
    realGuide: 'Nusuk Guide',
    ownership: 'Pilgrim Ownership',
    compatibility: 'Compatibility',
    passport: 'Passport:',
    noGuide: 'None',
    selectRealGuide: 'Select Nusuk Guide...',
    selectOwner: 'Select Owner...',
  },
  toasts: {
    realGuideUpdated: 'Nusuk guide updated successfully',
    realGuideUpdateFailed: 'Failed to update Nusuk guide',
    ownershipUpdated: 'Pilgrim ownership updated successfully',
    ownershipUpdateFailed: 'Failed to update pilgrim ownership',
  },
  compatibility: {
    match: 'Match',
    mismatch: 'Mismatch',
  },
  pilgrimGuideStore: {
    errors: {
      pilgrimNotFound: 'No pilgrim found with this passport number',
      linkFailed: 'Failed to link pilgrim to guide',
      deleteFailed: 'Failed to delete the link',
    },
    success: {
      linkSuccess: 'Pilgrim successfully linked to guide',
      deleteSuccess: 'Link deleted successfully',
    },
  },
  pilgrimsStore: {
    success: {
      uploadPilgrims: 'Successfully added {count} pilgrims',
    },
    errors: {
      uploadPilgrims: 'Failed to upload pilgrims',
      deletePilgrim: 'Failed to delete pilgrim',
      deleteAll: 'Failed to delete all pilgrims',
      searchPilgrims: 'Failed to search for pilgrims',
    },
  },
  addSuspensionModal: {
    title: 'Add New Suspension',
    labels: {
      suspensionType: 'Suspension Type',
      hotel: 'Hotel',
      selectHotel: 'Select Hotel',
      reason: 'Reason',
      duration: 'Duration',
      temporary: 'Temporary',
      permanent: 'Permanent',
      expiryDate: 'Expiry Date',
    },
    suspensionTypes: {
      linking: 'Linking Service Suspension',
      allAccommodation: 'All Accommodation Suspension',
      specificHotel: 'Specific Hotel Suspension',
      campAccommodation: 'Camp Accommodation Suspension',
    },
    buttons: {
      cancel: 'Cancel',
      addSuspension: 'Add Suspension',
      adding: 'Adding...',
    },
    errors: {
      allFieldsRequired: 'All fields are required',
      expiryDateRequired: 'Please select an expiry date',
      suspensionAddFailed: 'Failed to add suspension',
    },
    success: {
      suspensionAdded: 'Suspension added successfully',
    },
  },
  addBanModal: {
    title: 'Add New Ban',
    labels: {
      userType: 'User Type',
      guide: 'Guide',
      organizer: 'Organizer',
      selectUser: 'Select',
      banType: 'Ban Type',
      reason: 'Reason',
      duration: 'Duration',
      temporary: 'Temporary',
      permanent: 'Permanent',
      expiryDate: 'Expiry Date',
    },
    banTypes: {
      full: 'Full Ban',
      accommodation: 'Accommodation Ban',
      linking: 'Linking Ban',
      camp: 'Camp Ban',
    },
    buttons: {
      cancel: 'Cancel',
      addBan: 'Add Ban',
      adding: 'Adding...',
    },
    errors: {
      allFieldsRequired: 'All fields are required',
      expiryDateRequired: 'Please select an expiry date',
      banAddFailed: 'Failed to add ban',
    },
    success: {
      banAdded: 'Ban added successfully',
    },
  },
  campAccommodation: {
    errors: {
      serviceSuspended: 'Camp accommodation service is currently suspended',
      notAuthenticated: 'You are not authenticated',
      userBanned: 'You are banned from using the camp accommodation service',
      pilgrimNotFound: 'No pilgrim found with this passport number',
      noGuideLinked: 'Pilgrim is not linked to any guide',
      noPermission: 'You do not have permission to perform this action',
      tableNotFound: 'Accommodation table not found',
      tentNotFound: 'Tent not found',
      hallNotFound: 'Hall not found',
      genderMismatch:
        'Cannot assign pilgrim to this hall due to gender mismatch',
      notAuthorized: 'You are not authorized to perform this action',
    },
    header: {
      title: 'Camp Accommodation',
      subtitle: 'Manage pilgrim accommodation in Mina and Arafat camps',
    },
    addTableButton: 'Add Accommodation Table',
    stats: {
      totalCamps: 'Total Camps',
      occupiedTents: 'Occupied Tents',
      totalCapacity: 'Total Capacity',
      occupancyRate: 'Occupancy Rate',
    },
    noTablesMessage: 'No accommodation tables available',
  },
  bansManagement: {
    header: {
      title: 'Bans and Suspensions Management',
      subtitle: 'Manage user bans and service suspensions',
    },
    buttons: {
      addBan: 'Add New Ban',
      addSuspension: 'Suspend Service',
    },
    stats: {
      activeBans: 'Active Bans',
      expiredBans: 'Expired Bans',
      activeSuspensions: 'Active Suspensions',
      totalActions: 'Total Actions',
    },
    disputeBans: {
      title: 'Dispute Bans',
      bannedFrom: 'Banned from dealing with pilgrim',
      noBans: 'No dispute bans found',
    },
    activeBans: {
      title: 'Active Bans',
      guide: 'Guide',
      organizer: 'Organizer',
      expiresOn: 'Expires on',
      permanentBan: 'Permanent Ban',
      noBans: 'No active bans found',
    },
    activeSuspensions: {
      title: 'Active Suspensions',
      linking: 'Linking Service Suspension',
      allAccommodation: 'All Accommodation Suspension',
      specificHotel: 'Hotel',
      campAccommodation: 'Camp Accommodation Suspension',
      by: 'By',
      expiresOn: 'Expires on',
      permanentSuspension: 'Permanent Suspension',
      noSuspensions: 'No active suspensions found',
    },
    confirmDialog: {
      deactivateBanTitle: 'Deactivate Ban',
      deactivateBanMessage: 'Are you sure you want to deactivate this ban?',
      deactivateSuspensionTitle: 'Deactivate Suspension',
      deactivateSuspensionMessage:
        'Are you sure you want to deactivate this suspension?',
      deleteBanTitle: 'Delete Ban',
      deleteBanMessage: 'Are you sure you want to delete this ban permanently?',
      deleteSuspensionTitle: 'Delete Suspension',
      deleteSuspensionMessage:
        'Are you sure you want to delete this suspension permanently?',
      removeDisputeBanTitle: 'Remove Dispute Ban',
      removeDisputeBanMessage: 'Are you sure you want to remove the ban on',
      from: 'from',
      confirmText: 'Confirm',
      cancelText: 'Cancel',
    },
    success: {
      removeDisputeBan: 'Ban removed successfully',
      deactivateBan: 'Ban deactivated successfully',
      deactivateSuspension: 'Suspension deactivated successfully',
      deleteBan: 'Ban deleted successfully',
      deleteSuspension: 'Suspension deleted successfully',
    },
    errors: {
      fetchDisputeBans: 'Failed to fetch dispute bans',
      removeDisputeBan: 'Failed to remove ban',
      deactivateBan: 'Failed to deactivate ban',
      deactivateSuspension: 'Failed to deactivate suspension',
      deleteBan: 'Failed to delete ban',
      deleteSuspension: 'Failed to delete suspension',
    },
  },
  accommodationLogs: {
    header: 'Activity Logs',
    subheader: 'Tracking accommodation activities in hotels',
    searchPlaceholder: 'Search...',
    filters: {
      allHotels: 'All Hotels',
      allActions: 'All Actions',
      allRoles: 'All Roles',
      assign: 'Assign',
      remove: 'Remove',
      admin: 'Admin',
      guide: 'Guide',
      organizer: 'Organizer',
      search: 'Search',
      hotel: 'Hotel',
      action: 'Action',
      role: 'Role',
    },
    activeFilters: 'Active Filters:',
    logActions: {
      assign: 'Assigned',
      remove: 'Removed',
    },
    logDetails: {
      pilgrimInfo: 'Pilgrim Info',
      accommodationInfo: 'Accommodation Info',
      room: 'Room',
      bed: 'Bed',
      performedBy: 'Performed by:',
    },
    noLogs: 'No logs match the selected filters',
  },
  PilgrimGuide: {
    messages: {
      deleteSuccess: 'Link deleted successfully',
      deleteError: 'Failed to delete the link',
    },
    errors: {
      deletePermission: 'You do not have permission to delete this link',
      invalidLinkId: 'Invalid link ID',
      noDispute: 'No dispute available to submit proof',
    },
    confirmDialog: {
      deleteTitle: 'Delete Link',
      disputeMessage:
        'Deleting this link will end the dispute and grant rights to the other guide. Are you sure you want to delete the link for pilgrim {name}?',
      defaultMessage:
        'Are you sure you want to delete the link for pilgrim {name}?',
      deleting: 'Deleting...',
      delete: 'Delete',
      cancel: 'Cancel',
    },
  },
  evidenceModal: {
    title: 'Submit Evidence',
    textLabel: 'Evidence Text',
    textPlaceholder: 'Enter evidence details here...',
    textRequiredError: 'Evidence text is required',
    imageLabel: 'Evidence Image (optional)',
    uploadButton: 'Upload File',
    dragAndDrop: 'or drag and drop',
    fileRequirements: 'PNG, JPG up to 5MB',
    fileSizeError: 'File size must be less than 5MB',
    uploadError: 'Failed to upload image',
    uploadWaitError: 'Please wait until the image upload is complete',
    uploadingText: 'Uploading image...',
    cancelButton: 'Cancel',
    submitButton: 'Submit Evidence',
    savingButton: 'Saving...',
    submitSuccess: 'Evidence submitted successfully',
    submitError: 'Failed to submit evidence',
  },
  linkPilgrimToGuideAction: {
    banError:
      'You cannot link this pilgrim due to a ban from a previous dispute',
    alreadyLinkedError: 'This pilgrim is already linked to you',
    linkError: 'Failed to link pilgrim to guide',
  },
  deleteLinkAction: {
    linkNotFound: 'Link not found',
    deleteError: 'Failed to delete the link',
    hotelAccommodationError:
      'Cannot delete pilgrim as they are accommodated in hotel {hotelName} room {roomNumber}',
    campAccommodationError:
      'Cannot delete pilgrim as they are accommodated in camp {campName} tent {tentNumber} hall {hallNumber}',
  },
  activeFilters: {
    activeFiltersLabel: 'Active Filters:',
    searchLabel: 'Search:',
    statusLabel: 'Status:',
    countryLabel: 'Country:',
    statusApproved: 'Approved',
    statusPending: 'Pending',
    statusDisputed: 'Disputed',
    statusRejected: 'Rejected',
  },
  resetPasswordModal: {
    title: 'Change Password',
    newPasswordLabel: 'New Password',
    confirmPasswordLabel: 'Confirm Password',
    cancelButton: 'Cancel',
    saveButton: 'Save',
    savingButton: 'Saving...',
    passwordMismatch: 'Passwords do not match',
    passwordLengthError: 'Password must be at least 6 characters',
    passwordChangeSuccess: 'Password changed successfully',
    passwordChangeError: 'Failed to change password',
  },
  campAccommodationTable: {
    exportSuccess: 'Accommodation data exported successfully',
    exportError: 'Failed to export accommodation data',
    deleteSuccess: 'Accommodation table deleted successfully',
    deleteError: 'Failed to delete accommodation table',
    deleteTitle: 'Delete Accommodation Table',
    deleteMessage: 'Are you sure you want to delete the table?',
    deleteButton: 'Delete Table',
    confirmDelete: 'Delete',
    cancelDelete: 'Cancel',
    tents: 'Tents',
    capacity: 'Capacity',
    occupancyRate: 'Occupancy Rate',
    occupiedTotal: 'Occupied / Total',
    percentage: 'Percentage',
    viewDetails: 'View Details',
    exportTitle: 'Download Accommodation',
    exportButton: 'Download Accommodation',
  },
  settingsPage: {
    headerTitle: 'Settings',
    headerSubtitle: 'Manage account settings',
    changePasswordTitle: 'Change Password',
    currentPasswordLabel: 'Current Password',
    newPasswordLabel: 'New Password',
    newPasswordPlaceholder: 'Enter new password',
    updateButton: 'Update Password',
    updating: 'Updating...',
    newPasswordRequired: 'Please enter a new password',
    passwordLengthError: 'Password must be at least 6 characters',
    updateSuccess: 'Password updated successfully',
    updateError: 'Failed to update password',
    recentLoginRequired:
      'Please log out and log back in to update your password',
    fetchError: 'Failed to fetch user data',
  },
  pilgrimSelector: {
    searchPlaceholder: 'Search by pilgrim name or passport number...',
    passport: 'Passport',
    package: 'Package',
    noResults: 'No pilgrims match the search',
    startSearch: 'Start searching for a pilgrim...',
  },
  campBedModal: {
    tent: 'Tent',
    hall: 'Hall',
    bed: 'Bed',
    noPermissionAssign: 'You do not have permission to assign pilgrims',
    noPermissionRemove: 'You do not have permission to remove a pilgrim',
    noPermissionManage: 'You do not have permission to manage this bed',
    assignSuccess: 'Pilgrim assigned successfully',
    assignError: 'Failed to assign pilgrim',
    removeSuccess: 'Pilgrim removed successfully',
    removeError: 'Failed to remove pilgrim',
    removeButton: 'Remove Assignment',
    assignInstructions:
      'Please select a pilgrim to assign to this bed. Ensure the pilgrim:',
    assignRule1: 'Is not assigned elsewhere',
    assignRule2: 'Matches the hall type ({gender})',
    assignRule3: 'Is linked to an approved guide',
    male: 'Male',
    female: 'Female',
  },
  campDetails: {
    notFound: 'Accommodation table not found',
    stats: {
      totalTents: 'Total Tents',
      totalHalls: 'Total Halls',
      occupiedBeds: 'Occupied Beds',
      occupancyRate: 'Occupancy Rate',
    },
    filters: {
      searchPlaceholder: 'Search by tent number or pilgrim name...',
      allGenders: 'All Genders',
      male: 'Male',
      female: 'Female',
      allOccupancy: 'All Statuses',
      occupied: 'Occupied',
      available: 'Available',
    },
    tentHeader: 'Tent',
    hallHeader: 'Hall',
    available: 'Available',
  },
  room: {
    roomTypes: {
      double: 'Double',
      triple: 'Triple',
      quadruple: 'Quadruple',
    },
  },
  pilgrimsTable: {
    searchPlaceholder: 'Search by name or Nusk platform ID...',
    exportButton: 'Export Excel',
    activeFilters: 'Active Filters',
    filters: {
      allGenders: 'All Genders',
      male: 'Male',
      female: 'Female',
      allRoomTypes: 'All Room Types',
      double: 'Double',
      triple: 'Triple',
      quadruple: 'Quadruple',
      search: 'Search',
      gender: 'Gender',
      roomType: 'Room Type',
    },
    tableHeaders: {
      pilgrim: 'Pilgrim',
      packageInfo: 'Package Info',
      flightInfo: 'Flight Info',
      accommodation: 'Accommodation',
      contact: 'Contact',
      passport: 'Passport',
      serialNumber: 'Nusk Platform ID',
      pnr: 'PNR',
      ticket: 'Ticket',
      mainMakkahRoom: 'Main Makkah Room',
      shiftingMakkahRoom: 'Shifting Makkah Room',
      madinahRoom: 'Madinah Room',
      residence: 'Residence',
      nationality: 'Nationality',
    },
    pagination: {
      page: 'Page',
      of: 'of',
      pilgrims: 'Pilgrims',
    },
  },
  roomDetailsModal: {
    room: 'Room',
    roomInfo: 'Room Info',
    occupancy: 'Occupancy',
    pilgrims: 'Pilgrims',
    bed: 'Bed',
    guide: 'Guide',
    noPilgrims: 'No pilgrims in this room',
    roomTypes: {
      double: 'Double',
      triple: 'Triple',
      quadruple: 'Quadruple',
    },
  },
  landing: {
    hero: {
      title: 'Hajj and Umrah Management System',
      subtitle: 'Integrated',
      description:
        'Efficiently organize your operations through our integrated platform for managing accommodation, transportation, and pilgrim services',
      cta: 'Access the System',
    },
    features: {
      title: 'Key Features',
      accommodation: {
        title: 'Accommodation Management',
        description:
          'Efficiently manage pilgrim accommodation through an advanced housing system',
      },
      movement: {
        title: 'Movement Coordination',
        description: 'Track and coordinate pilgrim movements in real-time',
      },
      camp: {
        title: 'Camp Management',
        description:
          'Comprehensive tools for managing pilgrim camps and facilities',
      },
      services: {
        title: 'Pilgrim Services',
        description: 'Seamlessly deliver services to meet all pilgrim needs',
      },
    },
    benefits: {
      title: 'System Benefits',
      satisfaction: 'Customer Satisfaction',
      pilgrims: 'Pilgrims',
      support: '24/7 Support',
      features: 'Integrated Features',
    },
    systemFeatures: {
      title: 'Integrated System Features',
      hotel: {
        title: 'Hotel Management',
        description:
          'Interactive visual management of rooms and hotel occupancy',
      },
      flight: {
        title: 'Flight Management',
        description: 'Coordinate flight bookings and manage schedules',
      },
      task: {
        title: 'Task Tracking',
        description: 'Comprehensive task management and progress monitoring',
      },
      guide: {
        title: 'Guide Assignment',
        description: 'Efficient system for assigning and managing guides',
      },
    },
    finalCta: {
      title: 'Ready to Get Started?',
      description:
        'Access the dashboard to manage accommodation, movements, and pilgrim services',
      cta: 'Access the System',
    },
    stats: {
      totalCamps: 'Total Camps',
      occupiedTents: 'Occupied Tents',
      totalCapacity: 'Total Capacity',
      occupancyRate: 'Occupancy Rate',
      pilgrims: 'Pilgrims',
      camps: 'Camps',
      capacity: 'Capacity',
      rate: 'Rate',
    },
    systemBenefits: {
      title: 'System Advantages',
      efficiency: {
        title: 'High Efficiency',
        description: 'Smooth and effective management of all operations',
      },
      realTime: {
        title: 'Real-Time Updates',
        description: 'Track data and movements in real-time',
      },
      integration: {
        title: 'Comprehensive Integration',
        description: 'An integrated system that connects all services',
      },
      support: {
        title: '24/7 Technical Support',
        description: 'Support team available around the clock',
      },
    },
    mainFeatures: {
      title: 'Main Features',
      accommodation: {
        title: 'Accommodation Management',
        description: 'Efficiently manage pilgrim accommodations',
      },
      transportation: {
        title: 'Transportation Management',
        description: 'Organize pilgrim movements between holy sites',
      },
      tasks: {
        title: 'Task Management',
        description: 'Track and manage pilgrim and team tasks',
      },
      guides: {
        title: 'Guide Management',
        description: 'Assign and track guides for pilgrims',
      },
    },
  },
   auth: {
    loginTitle: 'Sign In',
    email: 'Email',
    password: 'Password',
    forgotPassword: 'Forgot Password?',
    login: 'Sign In',
    loggingIn: 'Signing in...',
    loginSuccess: 'Login successful',
    loginError: 'Login failed. Please check your email and password.',
    resetPassword: 'Reset Password',
    resetInstructions: 'Enter your email address and we will send you instructions to reset your password.',
    emailRequired: 'Email is required',
    resetSuccess: 'Password reset email sent. Please check your inbox.',
    resetError: 'Failed to send reset email. Please try again.',
    cancel: 'Cancel',
    sendResetLink: 'Send Reset Link',
    sending: 'Sending...',
    collaborationMessage: 'Powered by our partnership for excellence',
    collaborationSubtext: 'Bringing innovation to Hajj services',
    ithraaLogoAlt: 'Ithraa Al Khair',
    rehabLogoAlt: 'Rehab Company',
    copyright: '© 2025 All rights reserved to Rehab Company',
    poweredBy: 'System developed by Rehab Company'
  },
  authh: {
    logout: 'Logout',
  },
  components: {
    header: {
      userInfo: {
        organizerName: 'Organizer Name',
        gender: {
          male: 'Male',
          female: 'Female',
        },
      },
      logout: 'Logout',
    },
  },
  dashboard: {
    title: 'Dashboard',
    stats: {
      totalMembers: 'Total Members',
      activeMembers: 'Active Members',
      suspendedMembers: 'Suspended Members',
    },
    recentActivity: {
      title: 'Recent Activities',
      types: {
        login: 'Login',
        update: 'Data Update',
        create: 'Add New Member',
      },
    },
  },
  team: {
    title: 'Team',
    addMember: 'Add New Member',
    search: {
      placeholder: 'Search by name or email...',
      filters: {
        title: 'Active Filters',
        allRoles: 'All Roles',
        allGenders: 'All Genders',
        allStatuses: 'All Statuses',
        male: 'Male',
        female: 'Female',
        active: 'Active',
        suspended: 'Suspended',
        clearFilters: 'Clear Filters',
      },
    },
    noResults: 'No users match the selected filters',
    form: {
      title: {
        add: 'Add New Member',
        edit: 'Edit Member Details',
        selectRole: 'Select Role',
      },
      fields: {
        name: 'Name',
        email: 'Email',
        password: 'Password',
        gender: 'Gender',
        role: 'Role',
        status: 'Status',
      },
      buttons: {
        save: 'Save',
        saving: 'Saving...',
        cancel: 'Cancel',
      },
      validation: {
        required: 'This field is required',
        emailInvalid: 'Invalid email',
        passwordLength: 'Password must be at least 6 characters',
      },
    },
    delete: {
      title: 'Delete Member',
      message:
        'Are you sure you want to delete the member "{name}"? This action cannot be undone.',
      confirm: 'Delete',
      cancel: 'Cancel',
    },
    messages: {
      addSuccess: 'Member added successfully',
      addError: 'Failed to add member',
      updateSuccess: 'Member details updated successfully',
      updateError: 'Failed to update member details',
      deleteSuccess: 'Member deleted successfully',
      deleteError: 'Failed to delete member',
    },
  },
  roles: {
    title: 'Roles and Permissions',
    addRole: 'Add New Role',
    labels: {
      admin: 'System Administrator',
      guide: 'Guide',
      organizer: 'Organizer',
    },
    form: {
      title: {
        add: 'Add New Role',
        edit: 'Edit Role',
      },
      fields: {
        name: 'Role Name',
        permissions: 'Permissions',
      },
      sections: {
        dashboard: 'Dashboard',
        team: 'Team',
        roles: 'Roles and Permissions',
      },
      validation: {
        required: 'This field is required',
        selectPermissions: 'At least one permission must be selected',
      },
      buttons: {
        save: 'Save',
        saving: 'Saving...',
        cancel: 'Cancel',
      },
    },
    permissions: {
      title: 'Permissions',
      create: 'Create',
      read: 'Read',
      update: 'Update',
      delete: 'Delete',
    },
    actions: {
      edit: 'Edit',
      delete: 'Delete',
    },
    delete: {
      title: 'Delete Role',
      message:
        'Are you sure you want to delete the role "{name}"? This action cannot be undone.',
      confirm: 'Delete',
      cancel: 'Cancel',
    },
    messages: {
      addSuccess: 'Role added successfully',
      addError: 'Failed to add role',
      updateSuccess: 'Role updated successfully',
      updateError: 'Failed to update role',
      deleteSuccess: 'Role deleted successfully',
      deleteError: 'Failed to delete role',
    },
  },
  organizers: {
    title: 'Organizers',
    addOrganizer: 'Add New Organizer',
    form: {
      title: {
        add: 'Add New Organizer',
        edit: 'Edit Organizer Details',
      },
      fields: {
        name: 'Name',
        email: 'Email',
        password: 'Password',
        confirmPassword: 'Confirm Password',
      },
      validation: {
        required: 'This field is required',
        emailInvalid: 'Invalid email',
        passwordLength: 'Password must be at least 6 characters',
        passwordsNotMatch: 'Passwords do not match',
      },
      buttons: {
        save: 'Save',
        saving: 'Saving...',
        cancel: 'Cancel',
      },
    },
    table: {
      name: 'Organizer',
      email: 'Email',
      password: 'Password',
      actions: 'Actions',
    },
    actions: {
      edit: 'Edit',
      delete: 'Delete',
      resetPassword: 'Change Password',
      showPassword: 'Show Password',
      hidePassword: 'Hide Password',
      copyEmail: 'Copy Email',
      copyPassword: 'Copy Password',
    },
    messages: {
      addSuccess: 'Organizer added successfully',
      addError: 'Failed to add organizer',
      updateSuccess: 'Organizer details updated successfully',
      updateError: 'Failed to update organizer details',
      deleteSuccess: 'Organizer deleted successfully',
      deleteError: 'Failed to delete organizer',
      resetSuccess: 'Password changed successfully',
      resetError: 'Failed to change password',
      copySuccess: 'Copied successfully',
      copyError: 'Failed to copy',
    },
    delete: {
      title: 'Delete Organizer',
      message:
        'Are you sure you want to delete the organizer "{name}"? This action cannot be undone.',
      confirm: 'Delete',
      cancel: 'Cancel',
    },
    resetPassword: {
      title: 'Change Password',
      newPassword: 'New Password',
      confirmPassword: 'Confirm Password',
    },
  },
  management: {
    title: 'Management',
  },
  menu: {
    dashboard: 'Dashboard',
    pilgrims: 'Pilgrims',
    packages: 'Packages',
    flights: 'Flights',
    verification: 'Verification',
    pilgrimGuide: 'Link Pilgrims',
    linkingStatus: 'Linking Status',
    disputes: 'Disputes',
    accommodationTasks: 'Accommodation Tasks',
    accommodation: 'Accommodation',
    hotelVisualization: 'Hotel Visualization',
    team: 'Team',
    roles: 'Roles and Permissions',
    organizers: 'Organizers',
    guides: 'Guides',
    movements: 'Movement Schedule',
    campAccommodation: 'Camp Accommodation',
    accommodationLogs: 'Accommodation Logs',
    settings: 'Settings',
    bans: 'Bans Management',
    pilgrimOwnership: 'Pilgrim Ownership',
    organizerFinance: 'Organizer Finance',
    verificationWizard: 'Guide/Organizer Contract',
    verificationApproval: 'Organizer/Guide Contracts',
  },
  menuGroups: {
    dashboard: 'Dashboard',
    management: 'Data Management',
    linking: 'Linking',
    accommodation: 'Accommodation',
    settings: 'Settings',
  },
  pilgrimGuide: {
    header: 'Link Pilgrims to Guides',
    guideDescription: 'Add pilgrims to your supervision list.',
    adminDescription:
      'Link pilgrims to appropriate guides and manage their relationship.',
    addButton: 'Add Pilgrim',
    linkButton: 'Link Pilgrim to Guide',
  },
  accommodation: {
    header: 'Hotel Accommodation',
    description: 'Manage pilgrim accommodation in hotels',
    addButton: 'Add Accommodation Table',
    noTables: 'No accommodation tables available',
    errors: {
      serviceSuspended: 'Accommodation service is currently suspended',
      hotelSuspended: 'This hotel is currently suspended',
      notAuthenticated: 'You are not authenticated',
      notAuthorized: 'You are not authorized to perform this action',
      userBanned: 'You are banned from using the accommodation service',
      packageNotFound: 'Package not found for pilgrim',
      hotelNotAssigned: "This hotel is not assigned to the pilgrim's package",
      pilgrimNotFound: 'No pilgrim found with this passport number',
      noGuideLinked: 'Pilgrim is not linked to any guide',
      noPermission: 'You do not have permission to perform this action',
      tableNotFound: 'Accommodation table not found',
      roomNotFound: 'Room not found',
      roomNumberExists: 'Room number already exists',
      commentTextRequired: 'Comment text is required',
      userInfoRequired: 'User information is required',
      noComments: 'No comments found',
      invalidRoomNumber: 'Invalid room number',
      invalidRoomType: 'Invalid room type',
      excelParseError:
        'Failed to read Excel file. Please ensure the data is valid',
    },
  },
  pilgrimGuideDetails: {
    header: {
      basicInfo: 'Pilgrim Information',
      contactInfo: 'Contact Information',
      locationInfo: 'Accommodation Information',
      hotelInfo: 'Hotel Information',
      mainMakkahHotel: 'Main Makkah Hotel',
      shiftingMakkahHotel: 'Shifting Makkah Hotel',
      madinahHotel: 'Madinah Hotel',
    },
    labels: {
      name: 'Name',
      passport: 'Passport Number',
      gender: {
        male: 'Male',
        female: 'Female',
      },
      age: 'Age',
      mobile: 'Mobile Number',
      email: 'Email',
      residenceCountry: 'Residence Country',
      nationality: 'Nationality',
      hotelName: 'Hotel Name',
      roomType: 'Room Type',
      roomNumber: 'Room Number',
      years: 'Years',
    },
  },
  statusBadge: {
    statuses: {
      approved: 'Approved',
      disputed: 'Disputed',
      rejected: 'Rejected',
      pending: 'Pending',
    },
    actions: {
      viewEvidence: 'View Evidence',
      editEvidence: 'Edit',
      submitEvidence: 'Submit Evidence',
    },
  },
  linkingTable: {
    filters: {
      searchPlaceholder: 'Search by pilgrim name or passport number...',
      allStatuses: 'All Statuses',
      approved: 'Approved',
      pending: 'Pending',
      rejected: 'Rejected',
      allCountries: 'All Countries',
      activeFilters: 'Active Filters',
      search: 'Search',
      status: 'Status',
      country: 'Country',
    },
    tableHeaders: {
      pilgrim: 'Pilgrim Information',
      package: 'Package',
      guideAndOrganizer: 'Guide and Organizer',
      status: 'Status',
    },
    pagination: {
      page: 'Page',
      of: 'of',
      pilgrimsCount: 'Pilgrims',
    },
  },
  packageInfo: {
    pilgrimType: 'Pilgrim Type',
    nusukGroup: 'Nusuk Group',
  },
  pilgrimGuideTable: {
    headers: {
      pilgrimInfo: 'Pilgrim Info',
      package: 'Package',
      guideAndOrganizer: 'Guide & Organizer',
      status: 'Status',
    },
    pagination: {
      page: 'Page',
      of: 'of',
      pilgrimCount: 'Pilgrims',
    },
  },
  pilgrimInfo: {
    passport: 'Passport',
  },
  filters: {
    searchPlaceholder: 'Search by pilgrim name, passport number, or PNR...',
    allGenders: 'All Genders',
    allCountries: 'All Countries',
    male: 'Male',
    female: 'Female',
    allNationalities: 'All Nationalities',
    unitedKingdom: 'United Kingdom',
    malaysia: 'Malaysia',
    indonesia: 'Indonesia',
    allPackages: 'All Package Types',
    mainPackage: 'Main',
    shiftingPackage: 'Shifting',
    allHotels: 'All Hotels',
    vocoHotel: 'Voco Hotel',
    hiltonHotel: 'Hilton Hotel',
    marriottHotel: 'Marriott Hotel',
    allStatuses: 'All Statuses',
    approved: 'Approved',
    pending: 'Pending',
    rejected: 'Rejected',
    activeFilters: 'Active Filters',
    search: 'Search',
    gender: 'Gender',
    nationality: 'Nationality',
    packageType: 'Package Type',
    hotel: 'Hotel',
    status: 'Status',
    clearFilters: 'Clear Filters',
  },
  statusFilter: {
    allStatuses: 'All Statuses',
    approved: 'Approved',
    pending: 'Pending',
    rejected: 'Rejected',
    disputed: 'Disputed',
  },
  searchInput: {
    placeholder: 'Search by pilgrim name or passport number...',
  },
  statistics: {
    rooms: 'Rooms',
    occupiedTotal: 'Occupied / Total',
    beds: 'Beds',
    occupiedCapacity: 'Occupied / Capacity',
    occupancyRate: 'Occupancy Rate',
    percentage: 'Percentage',
  },
  actions: {
    viewDetails: 'View Details',
    download: 'Download Accommodation',
    deleteTable: 'Delete Table',
  },
  messages: {
    exportSuccess: 'Accommodation data exported successfully',
    exportError: 'Failed to export accommodation data',
    deleteSuccess: 'Accommodation table deleted successfully',
    deleteError: 'Failed to delete accommodation table',
  },
  confirmDialog: {
    deleteTitle: 'Delete Accommodation Table',
    deleteMessage: 'Are you sure you want to delete the table "{name}"?',
    delete: 'Delete',
    cancel: 'Cancel',
  },
  roomStats: {
    rooms: 'Room Statistics',
    occupiedTotal: 'Occupied / Total',
    beds: 'Bed Statistics',
    occupiedCapacity: 'Occupied / Capacity',
    guestDistribution: 'Guest Distribution',
    male: 'Male',
    female: 'Female',
    occupancyRate: 'Occupancy Rate',
    highOccupancy: 'High Occupancy',
    mediumOccupancy: 'Medium Occupancy',
    lowOccupancy: 'Low Occupancy',
  },
  roomTable: {
    headers: {
      roomNumber: 'Room Number',
      roomType: 'Room Type',
      capacity: 'Capacity',
      occupancy: 'Occupancy',
      actions: 'View',
    },
    roomTypes: {
      double: 'Double',
      triple: 'Triple',
      quad: 'Quad',
    },
  },
  roomTableRow: {
    roomTypes: {
      double: 'Double Room',
      triple: 'Triple Room',
      quadruple: 'Quadruple Room',
    },
    capacity: 'Capacity',
    statuses: {
      available: 'Available',
      full: 'Full',
      partial: 'Partially Available',
      availableBed: 'Available Bed',
    },
    years: 'Years',
    actions: {
      viewDetails: 'View Details',
    },
  },
  errors: {
    loadRoom: 'Failed to load room details',
    assignPermission: 'You do not have permission to assign pilgrims',
    removePermission: 'You do not have permission to remove pilgrims',
    invalidRoomNumber: 'Please enter a valid room number',
    assignFailed: 'Failed to assign pilgrim',
    removeFailed: 'Failed to remove pilgrim',
    updateRoomNumber: 'Failed to update room number',
    emptyComment: 'Comment text is required',
    notLoggedIn: 'You must log in to add a comment',
    addComment: 'Failed to add comment',
    deleteComment: 'Failed to delete comment',
  },
  success: {
    assignPilgrim: 'Pilgrim assigned successfully',
    removePilgrim: 'Pilgrim removed successfully',
    updateRoomNumber: 'Room number updated successfully',
    addComment: 'Comment added successfully',
    deleteComment: 'Comment deleted successfully',
  },
  roomViewModal: {
    title: 'Room',
    editTitle: 'Edit Room Number',
    placeholder: 'Enter new room number',
    roomType: 'Room Type',
    double: 'Double',
    triple: 'Triple',
    quadruple: 'Quadruple',
    bedsCount: 'Number of Beds',
    assignNew: 'Assign New Pilgrim',
  },
  pilgrimCard: {
    bed: 'Bed',
    years: 'Years',
    checkIn: 'Check-in Date',
    checkOut: 'Check-out Date',
    remove: 'Remove Assignment',
    assignNew: 'Assign New Pilgrim',
    guide: 'Guide',
  },
  commentSection: {
    header: 'Comments and Notes',
    delete: 'Delete Comment',
    placeholder: 'Write a comment...',
  },
  roomFilters: {
    placeholders: {
      search: 'Search by room number...',
    },
    options: {
      allRoomTypes: 'All Room Types',
      double: 'Double',
      triple: 'Triple',
      quadruple: 'Quadruple',
      allStatuses: 'All Statuses',
      occupied: 'Occupied',
      available: 'Available',
      partial: 'Partially Occupied',
    },
    activeFilters: 'Active Filters',
    labels: {
      search: 'Search',
      roomType: 'Room Type',
      status: 'Status',
    },
  },
  accommodationTasks: {
    header: 'Accommodation Tasks',
    subheader: 'Track the status of pilgrim accommodation in hotels',
    stats: {
      totalPilgrims: 'Total Pilgrims',
      accommodated: 'Accommodated',
      pending: 'Pending',
      completionRate: 'Completion Rate',
    },
    filters: {
      title: 'Filter Options',
    },
    noResults: 'No pilgrims match the selected filters',
  },
  tasksFilters: {
    searchPlaceholder: 'Search by pilgrim name or country...',
    gender: {
      all: 'All Genders',
      male: 'Male',
      female: 'Female',
    },
    status: {
      all: 'All Statuses',
      completed: 'Accommodated',
      pending: 'Pending',
    },
    activeFilters: 'Active Filters:',
    labels: {
      search: 'Search',
      gender: 'Gender',
      status: 'Status',
    },
  },
  accommodationTasksList: {
    headers: {
      pilgrim: 'Pilgrim',
      package: 'Package',
      mainMakkah: 'Main Makkah Hotel',
      shiftingMakkah: 'Shifting Makkah Hotel',
      madinah: 'Madinah Hotel',
    },
    room: 'Room',
  },
  common: {
    notSpecified: 'Not Specified',
    notAvailable: 'Not Available',
    pilgrims: 'Pilgrims',
    delete: 'Delete',
    cancel: 'Cancel',
    loading: 'Loading...',
    error: 'An error occurred while loading',
  },
  pagination: {
    page: 'Page',
    of: 'of',
  },
  recentPilgrims: {
    title: 'Recently Added Pilgrims',
    statuses: {
      approved: 'Approved',
      disputed: 'Disputed',
      pending: 'Pending',
    },
  },
  organizerStats: {
    totalGuides: 'Guides',
    totalPilgrims: 'Total Pilgrims',
    pendingLinks: 'Pending Links',
    disputes: 'Disputes',
  },
  guidesPage: {
    title: 'Guides',
    organizerDescription: 'Manage guides under your organization',
    adminDescription: 'Manage all guides in the system',
  },
  guidesList: {
    title: 'Guides',
    addButton: 'Add Guide',
    resetPassword: 'Reset Password',
    deleteTitle: 'Delete Guide',
    deleteMessage: 'Are you sure you want to delete the guide "{name}"?',
    noGuides: 'No guides available',
  },
  pilgrimGuideList: {
    noPilgrims: 'No pilgrims linked yet',
  },
  addGuideModal: {
    title: 'Add New Guide',
    requiredFields: 'All fields are required',
    successMessage: 'Guide added successfully',
    errorMessage: 'An error occurred while adding the guide',
    toastError: 'Failed to add guide',
  },
  guideForm: {
    labels: {
      name: 'Name',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Confirm Password',
    },
    errors: {
      name: 'This field is required',
      emailRequired: 'This field is required',
      invalidEmail: 'Invalid email',
      passwordRequired: 'This field is required',
      passwordLength: 'Password must be at least 6 characters',
      passwordMismatch: 'Passwords do not match',
    },
    submit: 'Save',
    loading: 'Saving...',
  },
  addPilgrimModal: {
    titleGuide: 'Add Pilgrim',
    titleAdminOrganizer: 'Link Pilgrim to Guide',
    passportError: 'Please enter a passport number',
    guideError: 'Please select a guide',
    pilgrimNotFound: 'No pilgrim found with this number',
    guideNotFound: 'Guide not found',
    unauthorized: 'Unauthorized operation',
    success: 'Pilgrim added successfully',
    addButton: 'Add',
    addingButton: 'Adding...',
    cancelButton: 'Cancel',
  },
  pilgrimAssignment: {
    errorNoPassport: 'Please enter a passport number',
    errorAssign: 'Failed to assign pilgrim',
    placeholder: 'Enter passport number',
    submitLoading: 'Verifying...',
    submit: 'Assign Pilgrim',
  },
  passportInput: {
    label: 'Passport Number',
    requiredMark: '*',
    placeholder: 'Enter passport number',
    loading: 'Loading...',
  },
  guideSearch: {
    label: 'Guide',
    requiredMark: '*',
    placeholder: 'Search by guide name or email...',
    noGuidesFound: 'No guides available',
    noMatchingGuides: 'No guides match the search',
  },
  hotelVisualizationPage: {
    headerTitle: 'Hotel Visualization',
    headerSubtitle: 'View hotel, building, and room details',
    hotelSelectionTitle: 'Select Hotel',
    buildingSelectionTitle: 'Select Building',
  },
  buildingView: {
    floorNavigationTitle: 'Floors',
    floorNavigationSubtitle: 'Select a floor to view its details',
  },
  hotelFloor: {
    floorLabel: 'Floor',
  },
  hotelSelector: {
    singleBuilding: 'Single Building',
    multipleBuildings: '{count} Buildings',
  },
  guideStats: {
    registeredPilgrims: 'Registered Pilgrims',
    accommodatedPilgrims: 'Accommodated',
    pendingPilgrims: 'Pending',
    disputes: 'Disputes',
  },
  bedList: {
    available: 'Available for assignment!',
    bed: 'Bed',
    assign: 'Assign Pilgrim',
  },
};
